<template>
  <div>
    <div>
      <div class="separator text-navy"><strong class="px-2">DOF</strong></div>
    </div>
    <div>
      <div
        class="mt-2 shadow-sm p-2 bg-white rounded d-flex align-items-center justify-content-between"
      >
        <el-input-number
          :controls="false"
          :min="0"
          :max="300"
          size="mini"
          v-model="dof_ini"
          @input="changeSlide"
          style="width: 65px"
        ></el-input-number>
        <el-slider
          class="filter-slider"
          style="width: 85%"
          v-model="dof"
          :show-stops="false"
          :step="10"
          :max="300"
          range
          @change="changePoints"
        >
        </el-slider>
        <el-input-number
          :controls="false"
          :min="0"
          :max="300"
          size="mini"
          v-model="dof_end"
          @input="changeSlide"
          style="width: 65px"
        ></el-input-number>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clearChild: {
      type: Number,
    },
  },
  data() {
    return {
      dof: [0, 0],
      dof_ini: 0,
      dof_end: 0,
    };
  },
  watch: {
    clearChild: function (newVal, oldVal) {
      this.clear();
    },
  },
  created() {},
  mounted() {},
  methods: {
    clear() {
      this.dof = [0, 0];
      this.dof_ini = 0;
      this.dof_end = 0;
    },
    changePoints(event) {
      this.dof_ini = this.dof[0];
      this.dof_end = this.dof[1];
      this.$emit("dof", this.dof);
    },
    changeSlide() {
      this.dof = [this.dof_ini, this.dof_end];
      this.$emit("dof", this.dof);
    },
  },
};
</script>
